import styled from "styled-components";

export const LoginContainer = styled.div`
    height: 100dvh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const LoginForm = styled.form`
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    width: 340px;
`